import axios from '@axios'

export default {
  namespaced: true,
  actions: {

//devices module  start
  getGeofenceslinkedToDeivce(ctx, queryParams) {
     
  return new Promise((resolve, reject) => {
    axios.get('links', {params: queryParams})
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
},


linkThis(data) {
  return new Promise((resolve, reject) => {
    axios.post(`links`, data).then(res => resolve(res.data))
      .catch(reason => reject(reason.response))
  })
},

//devices module end


//alerts start


    userGetLinkedAlerts(ctx, queryParams) {
     
      return new Promise((resolve, reject) => {
        axios.get('links', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  

    //alert end
    userGetLinked(ctx, queryParams) {
     
      return new Promise((resolve, reject) => {
        axios.get('userGetLinked', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    //
    userGetRoles(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('link/userGetRoles', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    userGiveRoles(ctx, data) {
      return new Promise((resolve, reject) => {
        axios.post('link/userGiveRoles', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    userLinkTo(ctx, q) {
      return new Promise((resolve, reject) => {
        axios.post('userLinkTo',   q )
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },

    getFilterBy(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('filters/getFilterBy', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    authMenus(ctx) {
      return new Promise((resolve, reject) => {
        axios.get('auth/menus-crud')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    userMenus(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios.get(`users/${id}/menus-crud`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    attachMenusToUser(ctx, { data, id }) {
      return new Promise((resolve, reject) => {
        axios.post(`users/${id}/attachMenus`,  { data: data } )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // devices

    authDevices(ctx, queryParams) {
      console.log(queryParams)
      return new Promise((resolve, reject) => {
        axios.get('link/get_devices_to_link', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    userDevices(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios.get(`users/${id}/getDevicesPermissionsTable`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    attachDevicesToUser(ctx, { data, id }) {
      return new Promise((resolve, reject) => {
        axios.post(`users/${id}/attachDevices`,  { data: data } )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },




    // geofence

    authGeofence(ctx, queryParams) {
      console.log(queryParams)
      return new Promise((resolve, reject) => {
        axios.get('getGeofencePermissionsTableForAuth', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    userGeofence(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios.get(`users/${id}/getGeofencePermissionsTable`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    attachGeofenceToUser(ctx, { data, id }) {
      return new Promise((resolve, reject) => {
        axios.post(`users/${id}/attachGeofence`,  { data: data } )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },



    // drivers

    authDrivers(ctx, queryParams) {
      console.log(queryParams)
      return new Promise((resolve, reject) => {
        axios.get('getDriversPermissionsTableForAuth', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    userDrivers(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios.get(`users/${id}/getDriversPermissionsTable`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    attachDriversToUser(ctx, { data, id }) {
      return new Promise((resolve, reject) => {
        axios.post(`users/${id}/attachDrivers`,  { data: data } )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },



    // calendars

    authCalendars(ctx, queryParams) {
      console.log(queryParams)
      return new Promise((resolve, reject) => {
        axios.get('getCalendarsPermissionsTableForAuth', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    userCalendars(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios.get(`users/${id}/getCalendarsPermissionsTable`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    attachCalendarsToUser(ctx, { data, id }) {
      return new Promise((resolve, reject) => {
        axios.post(`users/${id}/attachCalendars`,  { data: data } )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    // users

    authUsers(ctx, queryParams) {
      console.log(queryParams)
      return new Promise((resolve, reject) => {
        axios.get('getUsersPermissionsTableForAuth', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    userUsers(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios.get(`users/${id}/getUsersPermissionsTable`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    attachUsersToUser(ctx, { data, id }) {
      return new Promise((resolve, reject) => {
        axios.post(`users/${id}/attachUsers`,  { data: data } )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


  },
}
